import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DSControlValidationModule } from '@direction/control-validation';
import { DsGridModule } from '@direction/grid';
import { NgxPaginationModule } from 'ngx-pagination';
import { SgaInterceptorService } from '../core/services/sga-interceptor.service';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { CardGeneralStudentComponent } from './card-general-student/card-general-student.component';
import { GridComponent } from './grid/grid.component';
import { MatStepperLabelComponent } from './mat-stepper-label/mat-stepper-label.component';
import { SharedRoutingModule } from './shared.routing';

const MaterialModules = [MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatDatepickerModule];

const AngularModules = [HttpClientModule, ReactiveFormsModule, CommonModule, FormsModule];

@NgModule({
  declarations: [GridComponent, AutocompleteComponent, CardGeneralStudentComponent, MatStepperLabelComponent],
  imports: [
    DsGridModule,
    SharedRoutingModule,
    DSControlValidationModule,
    ...MaterialModules,
    ...AngularModules,
    NgxPaginationModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: SgaInterceptorService, multi: true }],
  exports: [AutocompleteComponent, CardGeneralStudentComponent, MatStepperLabelComponent, ...MaterialModules]
})
export class SharedModule {}
